__turbopack_context__.v({
  "card": "ApiSupport-module__8nIn8G__card",
  "cdesc": "ApiSupport-module__8nIn8G__cdesc",
  "ctitle": "ApiSupport-module__8nIn8G__ctitle",
  "desc": "ApiSupport-module__8nIn8G__desc",
  "eyebrow": "ApiSupport-module__8nIn8G__eyebrow",
  "grid": "ApiSupport-module__8nIn8G__grid",
  "icon": "ApiSupport-module__8nIn8G__icon",
  "pattern": "ApiSupport-module__8nIn8G__pattern",
  "section": "ApiSupport-module__8nIn8G__section",
  "title": "ApiSupport-module__8nIn8G__title",
  "wrap": "ApiSupport-module__8nIn8G__wrap",
});
